import request from '@/src/apis/axios';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  CustomersDto,
  CustomerStatsDto,
  CustomerType,
} from '@/src/models/CustomersDto';
import {
  GetCustomersRequestParams,
  PutCustomersRequestBody,
} from '@/src/apis/rest/customers.dtos';

const URL = {
  customers: '/admin/customers',
  customersEdit: '/admin/customers/{id}',
  customersDetail: '/admin/customers/{id}',
  customersExcel: '/admin/customers/excel/export',
  customersStats: '/admin/customers/customers-stats',
};

export const getCustomersAPI = async (
  requestParams: Partial<GetCustomersRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<CustomersDto>>({
    method: 'get',
    url: URL.customers,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(CustomersDto, data.rows);

  return { rows, count: data.count };
};

export const getCustomersByIdAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<CustomersDto>>({
    method: 'get',
    url: URL.customersDetail.replace('{id}', String(id)),
  });

  return plainToInstance(CustomersDto, data.row);
};

export const getCustomersExcelAPI = async (
  password: string,
  requestParams: Partial<GetCustomersRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.customersExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};

export const getCustomersStatsAPI = async (type: CustomerType) => {
  const { data } = await request({
    method: 'get',
    url: URL.customersStats,
    queryParams: { type },
  });

  return plainToInstance(CustomerStatsDto, data.row);
};

export const putCustomersAPI = async (
  id: number,
  requestBody: PutCustomersRequestBody,
) => {
  const { status } = await request({
    method: 'put',
    url: URL.customersEdit.replace('{id}', String(id)),
    requestBody,
  });

  return status;
};
